// Live project color palette. Legacy dropdown helpers live in dropdownOptions.legacy.ts.

export const PROJECT_COLORS = {
  cyan: "#2A95A8",
  red: "#D83636",
  purple: "#9D39E5",
  green: "#21872F",
  pink: "#E83AA5",
  blue: "#262E68",
  orange: "#E58939",
  yellow: "#E5C839",
  grey: "#6D6D6D",
  ochre: "#6D6A1B",
  fuchsia: "#611B6D",
  lime: "#86A82A",
}

export const UNKNOWN_PROJECT_COLOR = "#8F8C9C"
